import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent {
  @Input() loading: boolean = false
  @Input() fullScreen: boolean = false
  @Input() text: string = ''
  @Input() sm: boolean = false;
  @Input() width: number = 50;
  @Input() height: number = 50;

  
}
